<template>
    <div class="slider" >
        <section class="slider">
    <div class="flexslider" >
        <ul class="slides">
            <el-carousel :interval="5000" arrow="always">
                <el-carousel-item v-for="(li,index) in itemList">
                    <div class="all">
                        <div class="ban" v-for="(item,index) in li.list">
                            <div class="ban-in ban-grid">
                                <router-link :to="'/game/'+item.path" :title="item.title" target="_blank">
                                  <img class="null" src="static/images/topslide/null.png" alt="">
                                  <el-image class="img-responsive" :src="'static/images/topslide/'+item.path+'.jpg'" :alt="item.title">
<!--                                    <div slot="placeholder" class="img-placeholder slide">-->
<!--                                      图片加载中<span class="dot">...</span>-->
<!--                                    </div>-->
                                  </el-image>
                                </router-link>
                            </div>
                        </div>
                    </div>
                </el-carousel-item>
            </el-carousel>
        </ul>

    </div>

        </section>
    </div>
</template>

<script>
export default {
  name: 'Slider',
  components: {},
  data() {
    return {
      itemList: [],
      random: 0
    }
  },
  created() {
    this.getData()
  },
  activated: function() {
    this.getData()
  },
  mounted() {
  },
  methods: {
    getData() {
      var timeStamp = new Date().getTime()
      this.$http.get('static/data/home_slider.json' + '?' + timeStamp).then(res => {
        for (var i = 0; i < res.data.length; i++) {
          this.itemList.push(res.data[i])
        }
      },
      res => {
        console.log('error')
      }
      )
    }
  }

}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Home/Slider.vue